import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import { CustomerInfoModel } from "@/models/customerModels";
import baseUserContextComponent from "../baseUserContextComponent";
import axios, { AxiosPromise } from "axios";

@Component({})
export default class customerCurrentInfo extends baseUserContextComponent {
  @Prop({ default: "Info cliente" })
  title: string;

  @Prop({ default: "" })
  type: string;

  // @Prop({ default: () => new CustomerInfoModel() })
  customer: CustomerInfoModel = new CustomerInfoModel();
  @Prop({ default: () => null })
  customerId: number;
  @Watch("customerId")
  onCustomerIdChange(val: number, oldVal: number) {
    this.fetch();
  }
  fetch() {
    if (this.customerId != null) {
      axios
        .get<CustomerInfoModel>(`customer/${this.customerId}`)
        .then(res => {
          this.customer = res.data ? res.data : new CustomerInfoModel();
        })
        .catch(error => {
          console.error(error);
        });
    } else this.customer = new CustomerInfoModel();
  }
  mounted() {
    this.fetch();
  }
  // get customer(): CustomerInfoModel {
  //   var instance = this;
  //   return instance.getCurrentCustomer == null
  //     ? new CustomerInfoModel()
  //     : instance.getCurrentCustomer;
  // }
  get customerDescription(): string {
    var instance = this;
    if (instance.customer == null) return "";

    if (instance.customer.company) return instance.customer.company;

    var desc = instance.customer.firstName;
    if (instance.customer.middleName) {
      if (desc) desc += " ";
      desc += instance.customer.middleName;
    }
    if (instance.customer.lastName) {
      if (desc) desc += " ";
      desc += instance.customer.lastName;
    }
    return desc;
  }
  get agenteDescription(): string {
    var instance = this;
    if (
      instance.customer == null ||
      instance.customer.employees == null ||
      instance.customer.employees.length == 0
    )
      return "";

    var employee = instance.customer.employees[0];
    if (employee.name) return employee.name;
    var desc = employee.firstName;
    if (instance.customer.middleName) {
      if (desc) desc += " ";
      desc += instance.customer.middleName;
    }
    if (instance.customer.lastName) {
      if (desc) desc += " ";
      desc += instance.customer.lastName;
    }
    return desc;
  }

  get customerListino(): string {
    var instance = this;
    if (
      instance.customer == null ||
      instance.customer.condizioniCommerciali == null
    )
      return null;
    else
      return instance.customer.condizioniCommerciali.decrizionE_LISTINO
        ? instance.customer.condizioniCommerciali.decrizionE_LISTINO
        : instance.customer.condizioniCommerciali.codicE_LISTINO;
  }
  get customerScontistica(): string {
    var instance = this;
    if (instance.customer && instance.customer.scontistica) {
      return instance.customer.scontistica;
    }
    return "";
  }
  get customerContratto(): string {
    var instance = this;
    if (
      instance.customer == null ||
      instance.customer.condizioniCommerciali == null
    )
      return null;
    else
      return instance.customer.condizioniCommerciali.decrizionE_CONTRATTO
        ? instance.customer.condizioniCommerciali.decrizionE_CONTRATTO
        : instance.customer.condizioniCommerciali.codicE_CONTRATTO;
  }
}
